import React from 'react'
import styles from './Text1.module.scss'
import cl from 'classnames'
import { Text1Props } from './Text1.types'
import { ChangeMarkPoint } from '../ChangeMarkPoint'
import { RedMarkedText } from '../RedMarkedText'

const Text1Component = (props: Text1Props) => {
  const {
    bold,
    extraBold,
    overflowEllipsis,
    horizontalFillLine,
    className,
    children,
    versionChange,
    versionChangeAsLabel,
    overflowHidden,
    ...rest
  } = props

  return (
    <div
      className={cl({
        [styles.overflowHidden]: !versionChangeAsLabel,
        [styles.positionRelative]: versionChangeAsLabel,
        [styles.row]: versionChange?.valueBeforeChange,
        [styles.overflowHidden]: overflowHidden
      })}
    >
      {versionChange?.valueBeforeChange && (
        <RedMarkedText className={styles.redMarkedText}>
          {versionChange.valueBeforeChange}
        </RedMarkedText>
      )}

      <p
        className={cl(styles.text1, {
          [styles.bold]: bold,
          [styles.extraBold]: extraBold,
          [styles.textOverflow]: overflowEllipsis,
          [styles.positionRelative]: versionChangeAsLabel,
          [styles.red]: versionChange
        }, className)}
        {...rest}
      >
        {children}
        {horizontalFillLine && <span className={styles.horizontalLine} />}
      </p>

      {versionChangeAsLabel && (
        <ChangeMarkPoint
          className={styles.changeMarkPoint}
          {...versionChangeAsLabel}
        />
      )}
    </div>
  )
}

const Text1 = Text1Component
export { Text1 }
